<template>
  <div class="content-wrapper">
    <div class="setting-box">
      <div class="setting-item">
        <div class="setting-label">
          <span class="label-title">店铺主体类型</span>
          <span class="label-desc">个人C店以个人身份证开店，无营业执照、无企业税号；仅支持到税务局代开电子普票，不可开专票。</span>
        </div>
        <div class="setting-value">
          <span class="tag">{{ form.shop_type === 'personal' ? '个人店铺' : '企业店铺' }}</span>
        </div>
      </div>
      <div class="setting-item">
        <div class="setting-label">
          <span class="label-title">店铺支持发票类型</span>
          <span v-if="form.shop_type === 'personal'" class="label-desc">无企业资质，可在当地电子税务局网页/APP线上代开，或者带身份证去税务大厅线下代开</span>
          <span v-else class="label-desc">选择支持客户可申请的开票类型</span>
        </div>
        <div class="setting-value">
          <template v-if="form.shop_type === 'personal'">
            <span class="tag">电子普通发票</span>
          </template>
          <template v-else>
            <CheckboxGroup v-model="form.invoice_types">
              <Checkbox label="0">
                <span>电子普通发票</span>
              </Checkbox>
              <Checkbox label="1">
                <span>电子增值税专用发票</span>
              </Checkbox>
            </CheckboxGroup>
          </template>
        </div>
      </div>
      <div class="setting-item">
        <div class="setting-label">
          <span class="label-title">发票内容</span>
          <span class="label-desc">买家申请开票时显示的发票内容</span>
        </div>
        <div class="setting-value">
          <span class="tag grey-tag">商品明细</span>
        </div>
      </div>
      <div v-if="form.shop_type === 'enterprise'" class="setting-footer">
        <div class="btn cancel" @click="onCancel">取消</div>
        <div class="btn confirm" @click="onSave">保存设置</div>
      </div>
    </div>
  </div>
</template>

<script>
import { InvoiceSetting, InvoiceSettingSave } from '@/api/index'
export default {
  name: 'InvoiceSettingTab',
  props: {
    shopType: {
      type: String,
      default: 'personal',
    },
    invoiceTypes: {
      type: Array,
      default: () => ['0'],
    },
  },
  data() {
    return {
      loading: false,
      form: {
        shop_type: this.shopType || 'personal',
        invoice_types: [...(this.invoiceTypes || ['0'])],
      },
    }
  },
  watch: {
    shopType(val) {
      this.form.shop_type = val
    },
    invoiceTypes(val) {
      this.form.invoice_types = [...val]
    },
  },
  created() {
    this.fetchSetting()
  },
  methods: {
    async fetchSetting() {
      this.loading = true
      try {
        const res = await InvoiceSetting()
        const data = res.data || {}
        if (data.shop_type) {
          this.form.shop_type = data.shop_type
        }
        if (Array.isArray(data.invoice_types)) {
          this.form.invoice_types = data.invoice_types
        }
      } catch (e) {
        this.$Message.error((e && e.msg) || '获取设置失败')
      } finally {
        this.loading = false
      }
    },
    onCancel() {
      this.fetchSetting()
      this.$Message.info('已取消修改')
    },
    async onSave() {
      if (this.form.shop_type === 'enterprise' && !this.form.invoice_types.length) {
        this.$Message.warning('请至少选择一种支持的发票类型')
        return
      }
      try {
        await InvoiceSettingSave({
          invoice_types: [...this.form.invoice_types],
        })
        this.$Message.success('保存设置成功')
      } catch (e) {
        this.$Message.error((e && e.msg) || '保存失败')
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import './invoice-common.scss';

.setting-box {
  width: 860px;
  padding: 24px;
  border-radius: 10px 10px 10px 10px;
  border: 1px solid #E3E3E3;

  .setting-item {
    display: flex;
    align-items: flex-start;
    padding: 24px 0;
    border-bottom: 1px solid #f0f0f0;

    &:last-child {
      border-bottom: none;
      padding-bottom: 0;
    }

    .setting-label {
      flex: 1;

      .label-title {
        display: block;
        font-size: 14px;
        color: #1a1a1a;
        font-weight: bold;
        margin-bottom: 8px;
      }

      .label-desc {
        display: block;
        font-size: 12px;
        color: #999999;
        line-height: 1.6;
      }
    }

    .setting-value {
      flex-shrink: 0;
      min-width: 200px;
      text-align: right;

      .tag {
        display: inline-block;
        padding: 6px 16px;
        background: #fff0f1;
        border-radius: 4px;
        font-size: 14px;
        color: #ff5967;
      }
      .grey-tag {
        background: #f8f9fb;
        color: #333333;
      }

      ::v-deep .ivu-checkbox-wrapper {
        margin-right: 20px;
      }
    }
  }

  .setting-footer {
    display: flex;
    justify-content: flex-start;
    gap: 16px;
    margin-top: 30px;

    .btn {
      width: 120px;
      height: 40px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 4px;
      font-size: 14px;
      cursor: pointer;

      &.cancel {
        background: #ffffff;
        border: 1px solid #e3e3e3;
        color: #999999;
      }

      &.confirm {
        background: #ff5967;
        color: #ffffff;
      }
    }
  }
}

::v-deep .ivu-checkbox-checked .ivu-checkbox-inner {
  border-color: #FF5967 !important;
  background-color: #FF5967 !important;
}


::v-deep .ivu-checkbox-checked .ivu-checkbox-inner::after {
  border-color: #fff !important;
  // background-color: #FF5967 !important;
}
</style>
